<template>
  <div class="m-404">
    <img src="./../../assets/loading.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Page404',
}
</script>

<style lang="less" scoped>
.m-404 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
